module.exports = __webpack_public_path__ + "img/feijipiao.c7c53489.png";